
import { init_coverage } from './coverage_plugin';

$(document).ready(function() {
    if($("#header-coverage-search").length == 0) {
        return
    }
    let $sectionObj = $('#header-coverage-search');
    init_coverage($sectionObj);
});

if(window.mobileCheck()) {
    let headerHeight =  $('.header-section').outerHeight();
    let $imgWrapperHeight = 0;
    let $videoWrapperHeight = 0;
    let $contentWrapperHeight = 0;
    let newHeight = headerHeight;

    if($('.header-section .content-wrapper').length > 0) {
        $contentWrapperHeight = $('.header-section .content-wrapper').outerHeight();
    }

    if($('.header-section .bg-image-wrapper').length > 0) {
        $imgWrapperHeight = $('.header-section .bg-image-wrapper').outerHeight();
    }

    
    let $totalCurrentHeight = parseInt($contentWrapperHeight) + parseInt($imgWrapperHeight) + 15;
    
    if($totalCurrentHeight > headerHeight) {
        newHeight = $totalCurrentHeight
    }

    $('.header-section').css('height',newHeight+'px');
}